import axios from 'axios';
import path from '../../path';
// const token = sessionStorage.getItem("token");

// Create an Axios instance with default headers
const apiClient = axios.create({
    baseURL: path,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Helper function to get the auth token
const getAuthToken = () => sessionStorage.getItem("token");

// Add request interceptor to include token in headers
apiClient.interceptors.request.use(config => {
    const token = getAuthToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

export const getAllCustomQuestions = async (page, limit, search) => {
    try {
        const response = await apiClient.get(`/v1/typeform/get-all-questions`, {
            params: {
                page,
                limit, 
                search
            },
        });
        return response;
    } catch (error) {
        console.error('Error fetching user profile:', error);
        throw error;
    }
};

export const deleteCustomQuestion = async (id) => {
    try {
        const response = await apiClient.delete(`/v1/typeform/delete-question/${id}`, {
        });
        return response;
    } catch (error) {
        console.error('Error deleting question:', error);
        throw error;
    }
};

export const addCustomQuestion = async (data) => {
    try {
        const response = await apiClient.post(`/v1/typeform/create-question`, data);
        return response;
    } catch (error) {
        console.error('Error adding question:', error);
        throw error;
    }
};

export const updateCustomQuestion = async (id, data) => {
    try {
        const response = await apiClient.put(`/v1/typeform/update-question/${id}`, data);
        return response;
    } catch (error) {
        console.error('Error updating question:', error);
        throw error;
    }
};


// export const getTransactionAPIData = async (id) => {
//     try {
//         const response = await apiClient.get(`/v1/transactions/get-transaction-data/${id}`);
//         return response;
//     } catch (error) {
//         console.error('Error fetching user profile:', error);
//         throw error;
//     }
// };

export const getLocationQuestionsPaginated = async (page, limit, search) => {
    try {
        const response = await apiClient.get(`/v1/typeform/get-location-questions`, {
            params: {
                page,
                limit, 
                search
            },
        });
        return response;
    } catch (error) {
        console.error('Error fetching user profile:', error);
        throw error;
    }
};


export const deleteLocationQuestion = async (questionId) => {
    try {
        const response = await apiClient.delete(`/v1/typeform/remove-question`, {
            data: { questionId }
        });
        return response;
    } catch (error) {
        console.error('Error deleting question:', error);
        throw error;
    }
};


export const getAvailableCustomVariables = async ( ) => {
    try {
        const response = await apiClient.get(`/v1/typeform/get-available-variables`, {
        });
        return response;
    } catch (error) {
        console.error('Error fetching user profile:', error);
        throw error;
    }
};

export const postLocationQuestion = async (body) => {
    try {
        const response = await apiClient.post(`/v1/typeform/location-question`, body );
        return response;
    } catch (error) {
        console.error('Error deleting question:', error);
        throw error;
    }
};
